import React from 'react';

/**
 * Executive-style card primitive for dashboards.
 * Rounded-2xl, light border, minimal shadow — "briefing tile" feel.
 */
export function Card({ children, className = '', ...rest }) {
  return (
    <div
      className={`
        rounded-2xl
        bg-white
        border border-slate-200/60
        shadow-sm
        p-6
        ${className}
      `}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
